module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/~/babel-runtime/core-js/symbol.js
// module id = 53
// module chunks = 0